import { animate, query, sequence, style, transition, trigger } from "@angular/animations";

export const dropMenu = trigger('dropMenu', [
  transition(':enter', [
    query('.is-bg', [
      style({ opacity: 0 })
    ]),
    query('ul', [
      style({ height: 0, overflow: 'hidden', transform: 'translateX(100%)' }),
    ]),
    sequence([
      query('.is-bg', [
        animate('100ms ease', style({ opacity: 1 }))
      ]),
      query('ul', [
        animate('100ms', style({ height: '*', transform: 'none'})),
      ])
    ])
  ])
]);
